import React from 'react'
import { ReactComponent as SpeechBubbleLarge } from './assets/speechBubbleLarge.svg'
import { ReactComponent as SpeechBubbleMed } from './assets/speechBubbleMed.svg'
import Styles from './ImageAssembly.module.scss'
import cx from 'classnames'
import { largeCartoonTestimonials } from '../allTestimonials'
import DOMPurify from 'dompurify'

interface ImageAssemblyProps {
  page: string
  offsetTop: number
  showSmallPerson?: boolean
  useSmallerBubble?: boolean
}

const ImageAssembly: React.FC<ImageAssemblyProps> = ({ page, showSmallPerson, useSmallerBubble, offsetTop }) => {
  const { img: personIconUrl, name, position, company, quote, backgroundImageUrl } = largeCartoonTestimonials[page]
  const speechBubbleClass = backgroundImageUrl ? Styles.largeSpeech : Styles.lowBubble
  const quoteContainerClass = backgroundImageUrl ? Styles.quoteContainer : Styles.quoteContainerSmall
  const mainContainerClass = backgroundImageUrl ? Styles.mainContainer : Styles.noImageContainer

  const getImageClass = (url: string | undefined, displaySmallPerson: Boolean | undefined): string => {
    if (displaySmallPerson) {
      return Styles.personIconSmall
    } else if (url) {
      return Styles.personIcon
    } else {
      return Styles.fallbackPersonIcon
    }
  }

  return (
    <div data-testid="image-assembly" className={cx(mainContainerClass)}>
      {backgroundImageUrl ? (
        <SpeechBubbleLarge className={cx(useSmallerBubble ? Styles.smallerSpeech : speechBubbleClass)} />
      ) : (
        <SpeechBubbleMed className={cx(speechBubbleClass)} />
      )}
      <div
        style={{ top: offsetTop ? `${offsetTop}px` : '' }}
        className={cx(useSmallerBubble ? Styles.quoteContainerMedium : quoteContainerClass)}
      >
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(quote) }} />
      </div>
      {backgroundImageUrl && <img src={backgroundImageUrl} alt="Background" className={Styles.bgImageContainer} />}
      <img
        src={personIconUrl}
        alt={`${name} Icon`}
        className={cx(getImageClass(backgroundImageUrl, showSmallPerson))}
      />
      <div className={cx(Styles.rolePanel)}>
        <h2 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(name) }} />
        <div className={cx(Styles.positionAndCompany)}>
          <span>
            {position} {company}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ImageAssembly
